import SearchBar from './SearchBar';
import ClearSearchButton from './clear-button';

export default { SearchBar, ClearSearchButton };
